import type { TGlobalFunctionTyped } from 'common/hooks/useTranslation';
import { type Activity } from 'modules/cards/hooks/useCardAggregateActivity';

export function getCardActivityTypeTranslation(
  activity: Activity,
  t: TGlobalFunctionTyped,
  isSubscription?: boolean,
): string | null {
  switch (activity.activity_type) {
    case 'ordered':
      return t('cards.activity.feed.ordered', { name: activity.user.fullname });
    case 'activated':
      return t('cards.activity.feed.activated', {
        name: activity.user.fullname,
      });
    case 'blocked':
      return isSubscription
        ? t('cards.activity.feed.paused', { name: activity.user.fullname })
        : t('cards.activity.feed.blocked', { name: activity.user.fullname });
    case 'unblocked':
      return isSubscription
        ? t('cards.activity.feed.unpaused', { name: activity.user.fullname })
        : t('cards.activity.feed.unblocked', {
            name: activity.user.fullname,
          });
    case 'paused':
      return t('cards.activity.feed.paused');
    case 'unpaused':
      return t('cards.activity.feed.unpaused');
    case 'lost':
      return t('cards.activity.feed.lost');
    case 'stolen':
      return t('cards.activity.feed.stolen');
    case 'damaged':
      return t('cards.activity.feed.damaged');
    case 'sms-pin-sent':
      return t('cards.activity.feed.smsPinSent');
    case 'sms-pin-set':
      return t('cards.activity.feed.smsPinSet');
    case 'budget-changed':
      return t('cards.activity.feed.budgetChanged');
    case 'allow-withdrawal':
      return t('cards.activity.feed.allowWithdrawal', {
        name: activity.user.fullname,
      });
    case 'deny-withdrawal':
      return t('cards.activity.feed.denyWithdrawal', {
        name: activity.user.fullname,
      });
    case 'allow-onlineUsage':
      return t('cards.activity.feed.allowOnlineUsage', {
        name: activity.user.fullname,
      });
    case 'deny-onlineUsage':
      return t('cards.activity.feed.denyOnlineUsage', {
        name: activity.user.fullname,
      });
    case 'allow-contactless':
      return t('cards.activity.feed.allowContactless', {
        name: activity.user.fullname,
      });
    case 'deny-contactless':
      return t('cards.activity.feed.denyContactless', {
        name: activity.user.fullname,
      });

    default:
      return null;
  }
}
